import React                                              from 'react'
import {Box, Button, Card, CardActionArea, Container, Divider, Typography} from '@mui/material'
import Grid                                               from '@mui/material/Unstable_Grid2'
import {useNavigate}                                      from "react-router-dom"
import {
	Insights, People, Category, MenuBook, Inventory2, Movie, Autorenew, Psychology,
	PlaylistPlay, Tune, DataObject, Palette, VpnKey, CloudUpload, Article, WavingHand, AutoAwesome, Campaign
} from "@mui/icons-material"

// Each tile links to an existing /admin/* route (unchanged), with an icon + subtitle.
const ADMIN_SECTIONS = [
	{label: 'Conversions',      url: '/admin/conversions',      Icon: Insights,     description: 'Signup and purchase conversion metrics.'},
	{label: 'Users',            url: '/admin/users',            Icon: People,       description: 'View and manage user accounts.'},
	{label: 'Categories',       url: '/admin/categories',       Icon: Category,     description: 'Manage exam categories.'},
	{label: 'Products',         url: '/admin/products',         Icon: MenuBook,     description: 'Products, topics, and questions.'},
	{label: 'Packages',         url: '/admin/packages',         Icon: Inventory2,   description: 'Packages and pricing options.'},
	{label: 'Videos',           url: '/admin/videos',           Icon: Movie,        description: 'Video jobs and generated media.'},
	{label: 'Active Media Jobs', url: '/admin/active-media-jobs', Icon: Autorenew,  description: 'Monitor in-progress media generation.'},
	{label: 'AI Personalities', url: '/admin/ai-personalities', Icon: Psychology,   description: 'Manage AI tutor personalities.'},
	{label: 'Prompts',          url: '/admin/prompts',          Icon: AutoAwesome,  description: 'Edit AI prompts, preview them with real values.'},
	{label: 'App Config',       url: '/admin/app-config',       Icon: Tune,         description: 'Application configuration values.'},
	{label: 'Topic/Question Prompts', url: '/admin/prompt-templates', Icon: Article,      description: 'Manage AI prompt templates.'},
	{label: 'Welcome Messages', url: '/admin/welcome-messages', Icon: WavingHand,   description: 'Sign-in screen copy, links and QR codes.'},
	{label: 'Announcement',     url: '/admin/announcements',    Icon: Campaign,     description: 'One message shown to existing users.'},
]

/*
 * Second tier: occasional tools rather than places you go to work. They were cards, which gave a
 * one-off debugging screen the same weight as Products -- so the eye had to read fifteen equal
 * tiles to find the one that matters. Buttons at the bottom, still one click away.
 */
const ADMIN_UTILITIES = [
	{label: 'Topic Job Queue',  url: '/admin/topic-job-queue',  Icon: PlaylistPlay, description: 'Topic generation job queue.'},
	{label: 'Bad JSON',         url: '/admin/bad-json',         Icon: DataObject,   description: 'Inspect malformed AI JSON output.'},
	{label: 'Palette',          url: '/admin/palette',          Icon: Palette,      description: 'Preview the theme colour palette.'},
	{label: 'Check Access',     url: '/admin/check-access',     Icon: VpnKey,       description: "Check a user's access to a prepkit."},
	{label: 'Import PrepKit',   url: '/admin/import-prepkit',   Icon: CloudUpload,  description: 'Bulk-import a prepkit.'},
]

function Admin() {
	const navigate = useNavigate()

	return (
		<Container maxWidth="lg" sx={{py: 4}}>
			<Typography variant="h5" sx={{mb: 3, fontWeight: 700}}>Admin</Typography>
			<Grid container spacing={2}>
				{ADMIN_SECTIONS.map(({label, url, Icon, description}) => (
					<Grid key={url} xs={12} sm={6} md={4} lg={3}>
						<Card variant="outlined" sx={{height: '100%', borderRadius: 3}}>
							<CardActionArea onClick={() => navigate(url)} sx={{height: '100%', p: 2, alignItems: 'flex-start'}}>
								<Box sx={{display: 'flex', flexDirection: 'column', gap: 1, height: '100%'}}>
									<Icon color="primary"/>
									<Typography sx={{fontWeight: 700}}>{label}</Typography>
									<Typography variant="body2" color="text.secondary">{description}</Typography>
								</Box>
							</CardActionArea>
						</Card>
					</Grid>
				))}
			</Grid>

			<Divider sx={{my: 4}}/>

			<Typography variant="overline" color="text.secondary">Tools</Typography>
			<Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1}}>
				{ADMIN_UTILITIES.map(({label, url, Icon}) => (
					<Button
						key={url}
						variant="outlined"
						size="small"
						startIcon={<Icon fontSize="small"/>}
						onClick={() => navigate(url)}
						sx={{textTransform: 'none', borderRadius: 2}}
					>
						{label}
					</Button>
				))}
			</Box>
		</Container>
	)
}

export default Admin
